export default __webpack_public_path__ + "static/media/30557391c0745bbd2ad99b9bcd7c38561599578825307.1fbefda2.webp";